import React, { Component } from "react";
import Media from "react-media";
import { StyledSection, StyledRow, StyledColumn, StyledLogoList } from "../styles/styledComponents/blocks";
import { H1, H3, P, PrimaryButton, CommitmentLogo } from "../styles/styledComponents/elements";
import broilerData from "../data/broiler.json";
import { fromThemeProps } from "../helpers/utilities";
import Themed from "../helpers/Themed";
import { renderTitleSpan } from "../helpers/renderTitleSpan";
import kraftLogo from "../assets/logos/kraft-heinz.svg";
import subwayLogo from "../assets/logos/subway-old.svg";
import nestleLogo from "../assets/logos/nestle-horiz.svg";
import campbellsLogo from "../assets/logos/campbells.svg";
import royalCaribbeanLogo from "../assets/logos/royal-carib.svg";
import carnivalLogo from "../assets/logos/carnival.svg";
import accorLogo from "../assets/logos/accor-hotels.svg";

export default class Broiler extends Component {
  render() {
    return (
      <div>
        {this.renderMain()}
        {this.renderCommitments()}
      </div>
    )
  }

  //
  // Partials
  //
  renderMain() {
    return (
      <StyledSection background={fromThemeProps("offWhite")}>
        <StyledRow paddingTop={fromThemeProps("headerHeight")}>
          <StyledColumn background="none" paddingTop="1.5em">
            <Themed alt>
              <H1><span>{broilerData.title1}</span></H1>
            </Themed>
            <br />
            <H3>{broilerData.subtitle1}</H3>
            <PrimaryButton to="/progress-tracker?filterK=Broiler">{broilerData.buttonText}</PrimaryButton>
            <P>{broilerData.p1}</P>
            <P>{broilerData.p2}</P>
            <P>{broilerData.p3}</P>
          </StyledColumn>
        </StyledRow>
      </StyledSection >
    );
  }

  renderCommitments() {
    return (
      <StyledSection>
        <StyledRow>
          <StyledColumn>
            <Media query="(max-width: 576px)">
              {matches =>
                matches ? (
                  <div>
                    {renderTitleSpan(broilerData, 'alt')}
                  </div>
                ) : (
                    <Themed alt>
                      <H1><span>{broilerData.titleSpan[0].titlePartial} {broilerData.titleSpan[1].titlePartial}</span> <span>{broilerData.titleSpan[2].titlePartial}</span></H1>
                    </Themed>
                  )
              }
            </Media>
            <br />
            <H3>{broilerData.subtitle2}</H3>
            <StyledLogoList>
              <li>
                <CommitmentLogo src={kraftLogo} />
              </li>
              <li>
                <CommitmentLogo src={subwayLogo} />
              </li>
              <li>
                <CommitmentLogo src={campbellsLogo} />
              </li>
              <li>
                <CommitmentLogo src={royalCaribbeanLogo} />
              </li>
              <li>
                <CommitmentLogo src={carnivalLogo} />
              </li>
              <li>
                <CommitmentLogo src={accorLogo} />
              </li>
              <li>
                <CommitmentLogo src={nestleLogo} />
              </li>
            </StyledLogoList>
          </StyledColumn>
        </StyledRow >
      </StyledSection >
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/broiler.js